<script>
import PicUpload from "@/components/pic-upload/PicUpload.vue";
import {request} from "@/config/request";

export default {
  name: "HardwareManageAdd",
  components: {PicUpload},
  data() {
    return {
      formData: {},
      formRules: {
        name: {required: true, message: this.$t('请输入硬件名称'), trigger: 'blur'},
        model: {required: true, message: this.$t('请输入产品型号'), trigger: 'blur'},
        brand: {required: true, message: this.$t('请输入产品品牌'), trigger: 'blur'},
        photo: {required: true, message: this.$t('请选择产品图片'), trigger: 'blur'},
        suitTemperature: {required: true, message: this.$t('请输入适用温度'), trigger: 'blur'},
        chipName: {required: true, message: this.$t('请输入芯片名称'), trigger: 'blur'},
        bluetoothName: {required: true, message: this.$t('请输入蓝牙版本名称'), trigger: 'blur'},
        sensorName: {required: true, message: this.$t('请输入传感器名称'), trigger: 'blur'},
        liquidCrystalName: {required: true, message: this.$t('请输入液晶名称'), trigger: 'blur'},
        powerWay: {required: true, message: this.$t('请输入供电方式'), trigger: 'blur'},
      }
    }
  },
  methods: {
    handleSubmit() {
      this.$refs.form.validate(async valid => {
        if(!valid) return;
        try {
          const params = {...this.formData};
          delete params.createTime;
          delete params.updateTime;
          await request(this.$api.intellectHardware.update, this.formData);
          this.$message.success(this.$t('操作成功'));
          this.$router.back();
        } catch (err) {
          console.error(err);
        }
      })
    },

    handleReset() {
      this.$refs.form.resetFields();
    },

    async loadDetail() {
      try {
        const res = await request(this.$api.intellectHardware.detail, this.$route.query);
        this.formData = res.intellectHardware;
      } catch (err) {
        console.error(err);
      }
    }
  },
  created() {
    this.loadDetail();
  }
}
</script>

<template>
  <el-card>
    <el-form label-width="110px" :model="formData" ref="form" :rules="formRules">
      <el-form-item :label="$t('硬件名称')" prop="name">
        <el-input placeholder="请输入硬件名称" v-model="formData.name" />
      </el-form-item>
      <el-form-item :label="$t('产品型号')" prop="model">
        <el-input placeholder="请输入产品型号" v-model="formData.model" />
      </el-form-item>
      <el-form-item :label="$t('产品品牌')" prop="brand">
        <el-input placeholder="请输入产品品牌" v-model="formData.brand" />
      </el-form-item>
      <el-form-item :label="$t('产品品牌图片')" prop="photo">
        <pic-upload
            :limit="1"
            v-model="formData.photo"
            :download-url="$api.file.downloadImg"
            :action="$api.file.upload"/>
      </el-form-item>
      <el-form-item :label="$t('适用温度')" prop="suitTemperature">
        <el-input placeholder="请输入适用温度" v-model="formData.suitTemperature" />
      </el-form-item>
      <el-form-item :label="$t('芯片名称')" prop="chipName">
        <el-input placeholder="请输入芯片名称" v-model="formData.chipName" />
      </el-form-item>
<!--      <el-form-item :label="$t('蓝牙版本名称')" prop="bluetoothName">-->
<!--        <el-input placeholder="请输入蓝牙版本名称" v-model="formData.bluetoothName" />-->
<!--      </el-form-item>-->
      <el-form-item :label="$t('传感器名称')" prop="sensorName">
        <el-input placeholder="请输入传感器名称" v-model="formData.sensorName" />
      </el-form-item>
      <el-form-item :label="$t('液晶名称')" prop="liquidCrystalName">
        <el-input placeholder="请输入液晶名称" v-model="formData.liquidCrystalName" />
      </el-form-item>
<!--      <el-form-item :label="$t('供电方式')" prop="powerWay">-->
<!--        <el-input placeholder="请输入供电方式" v-model="formData.powerWay" />-->
<!--      </el-form-item>-->
      <el-form-item :label="$t('协议代码')">
        <el-input placeholder="请输入协议代码" disabled :value="formData.protocolCode" />
      </el-form-item>
    </el-form>
    <div>
      <el-button type="primary" @click="handleSubmit">{{$t('确认')}}</el-button>
      <el-button @click="handleReset">{{$t('重置')}}</el-button>
    </div>
  </el-card>
</template>

<style scoped>

.el-form {
  width: 700px;
}

</style>
